'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var clsx = require('clsx');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var Panel = require('@narvar/nth-block-panel');
var PanelHeader = require('@narvar/nth-bit-panel-header');
var Edd = require('@narvar/nth-block-edd');
var TrackingStatus = require('@narvar/nth-block-tracking-status');
var ShippingActivity = require('@narvar/nth-bundle-shipping-activity');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var Divider = require('@narvar/nth-bit-divider');
var Paragraph = require('@narvar/nth-bit-paragraph');
var CarrierTrackingLink = require('@narvar/nth-block-carrier-tracking-link');
var PrefetchData = require('./PrefetchData.js');
var VPOD = require('@narvar/nth-bundle-vpod');
var EddPanel_module = require('./EddPanel.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var PanelHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelHeader);
var Edd__default = /*#__PURE__*/_interopDefaultLegacy(Edd);
var TrackingStatus__default = /*#__PURE__*/_interopDefaultLegacy(TrackingStatus);
var ShippingActivity__default = /*#__PURE__*/_interopDefaultLegacy(ShippingActivity);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var CarrierTrackingLink__default = /*#__PURE__*/_interopDefaultLegacy(CarrierTrackingLink);
var VPOD__default = /*#__PURE__*/_interopDefaultLegacy(VPOD);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const PackEddPanel = ({
  featureName,
  layout = FeatureLayout.PORTRAIT,
  fixedPanelHeight
}) => {
  const {
    packEddPanelFallbackMessage,
    packEddPanelTitleText
  } = nthHookTranslations.useTranslations();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const {
    state: {
      orderNumbers
    }
  } = nthHookContextPage.usePageContext();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    const orderNumber = orderNumbers && orderNumbers[0] || null;
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EDD_PANEL,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EDD_PANEL,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      orderNumber,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EDD_PANEL,
      pageOrderNumber: orderNumber,
      trackLayout: layout
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  // We show the fallback view if there's no shipment available
  const {
    isFallback,
    trackingNumber
  } = currentShipment ?? {
    isFallback: true
  };
  const columnLeftClasses = clsx__default["default"](!isLandscape && EddPanel_module["default"].columnLeft, isLandscape && EddPanel_module["default"].columnLeftLandscape);
  const columnRightClasses = clsx__default["default"](!isLandscape && EddPanel_module["default"].columnRight, isLandscape && EddPanel_module["default"].columnRightLandscape);
  const validShipmentColumns = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: columnLeftClasses
  }, /*#__PURE__*/React__default["default"].createElement(Edd__default["default"], {
    orderNumbers: orderNumbers,
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement(TrackingStatus__default["default"], {
    featureName: featureName,
    layout: layout
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: columnRightClasses
  }, /*#__PURE__*/React__default["default"].createElement(VPOD__default["default"], {
    layout: layout,
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement(ShippingActivity__default["default"], {
    featureName: featureName,
    layout: layout
  })));
  const fallbackShipmentColumns = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: columnLeftClasses
  }, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName,
    containerCustomStyle: {
      marginTop: 0,
      marginBottom: isLandscape && trackingNumber ? undefined : 0
    }
  }, packEddPanelFallbackMessage)), trackingNumber && /*#__PURE__*/React__default["default"].createElement("div", {
    className: columnRightClasses
  }, !isLandscape && /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement(CarrierTrackingLink__default["default"], {
    featureName: featureName,
    layout: layout
  })));
  const columns = isFallback ? fallbackShipmentColumns : validShipmentColumns;
  const containerClasses = clsx__default["default"](EddPanel_module["default"].container, isLandscape && EddPanel_module["default"].containerLandscape);
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    featureName: featureName,
    fixedPanelHeight: fixedPanelHeight,
    header: /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], {
      featureName: featureName
    }, packEddPanelTitleText)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: containerClasses
  }, columns));
};
const PackEddPanelWithData = nthHookTranslations.withTranslationsProvider(PackEddPanel, {
  translationKeys: ['packEddPanelFallbackMessage', 'packEddPanelTitleText']
});
const PackEddPanelWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(PackEddPanelWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports["default"] = PackEddPanelWithPrefetchedData;
